import { observer } from 'mobx-react-lite'
import { TextAreaContainer } from '@/components/inputs/TextAreaContainer'
import { ViewJobScopeChangeRequestDialog } from '@/features/jobs/details/components/ViewJobScopeChangeRequestDialog'
import { type ViewJobScopeChangeRequestDialogViewModel } from './ViewJobScopeChangeRequestDialogViewModel'

export interface ViewJobScopeChangeRequestDialogContainerProps {
  vm: ViewJobScopeChangeRequestDialogViewModel
}

export const ViewJobScopeChangeRequestDialogContainer = observer(
  function ViewJobScopeChangeRequestDialogContainer({
    vm,
  }: ViewJobScopeChangeRequestDialogContainerProps) {
    return (
      <ViewJobScopeChangeRequestDialog
        showing={vm.modal.showing}
        isAccepted={vm.scopeChangeRequest.isAccepted}
        isRejected={vm.scopeChangeRequest.isRejected}
        isApplyFailed={vm.scopeChangeRequest.isApplyFailed}
        isPending={vm.scopeChangeRequest.isPending}
        isCreatedByAdmin={vm.scopeChangeRequest.isCreatedByAdmin}
        latestResponseTime={
          vm.scopeChangeRequest.latestResponseTime ?? undefined
        }
        items={vm.scopeChangeRequest.items.map((item) => ({
          id: item.id,
          name: item.name,
          quantity: item.quantity,
        }))}
        rejectionReasonField={
          <TextAreaContainer
            rows={4}
            isDisabled
            model={vm.scopeChangeRequest}
            field="rejectionReason"
            name="rejectionReason"
          />
        }
        onClose={vm.modal.close}
      />
    )
  },
)
